import AustriaFlag from '../assets/images/flags-svg/072-austria.svg';
import BelgiumFlag from '../assets/images/flags-svg/209-belgium.svg';
import BulgariaFlag from '../assets/images/flags-svg/127-bulgaria.svg';
import CroatiaFlag from '../assets/images/flags-svg/128-croatia.svg';
import CyprusFlag from '../assets/images/flags-svg/233-cyprus.svg';
import CzechiaFlag from '../assets/images/flags-svg/202-czech republic.svg';
import DenmarkFlag from '../assets/images/flags-svg/191-denmark.svg';
import EstoniaFlag from '../assets/images/flags-svg/004-estonia.svg';
import FinlandFlag from '../assets/images/flags-svg/211-finland.svg';
import FranceFlag from '../assets/images/flags-svg/197-france.svg';
import GermanyFlag from '../assets/images/flags-svg/208-germany.svg';
import GreeceFlag from '../assets/images/flags-svg/192-greece.svg';
import HungaryFlag from '../assets/images/flags-svg/210-hungary.svg';
import IrelandFlag from '../assets/images/flags-svg/193-ireland.svg';
import ItalyFlag from '../assets/images/flags-svg/263-italy.svg';
import LatviaFlag from '../assets/images/flags-svg/231-latvia.svg';
import LithuaniaFlag from '../assets/images/flags-svg/238-lithuania.svg';
import LuxembourgFlag from '../assets/images/flags-svg/240-luxembourg.svg';
import MaltaFlag from '../assets/images/flags-svg/251-malta.svg';
import NetherlandsFlag from '../assets/images/flags-svg/nl.svg';
import PolandFlag from '../assets/images/flags-svg/165-poland.svg';
import PortugalFlag from '../assets/images/flags-svg/098-portugal.svg';
import RomaniaFlag from '../assets/images/flags-svg/213-romania.svg';
import SlovakiaFlag from '../assets/images/flags-svg/218-slovakia.svg';
import SloveniaFlag from '../assets/images/flags-svg/259-slovenia.svg';
import SpainFlag from '../assets/images/flags-svg/230-spain.svg';
import SwedenFlag from '../assets/images/flags-svg/190-sweden.svg';

export { NetherlandsFlag };

export const EU_COUNTRIES = [
    { slug: 'austria', name: 'Austria', language: 'de', nativeName: 'Österreich' },
    { slug: 'belgium', name: 'Belgium', language: 'nl', nativeName: 'België' },
    { slug: 'bulgaria', name: 'Bulgaria', language: 'bg', nativeName: 'България' },
    { slug: 'croatia', name: 'Croatia', language: 'hr', nativeName: 'Hrvatska' },
    { slug: 'cyprus', name: 'Cyprus', language: 'el', nativeName: 'Κύπρος' },
    { slug: 'czechia', name: 'Czechia', language: 'cs', nativeName: 'Česko' },
    { slug: 'denmark', name: 'Denmark', language: 'da', nativeName: 'Danmark' },
    { slug: 'estonia', name: 'Estonia', language: 'et', nativeName: 'Eesti' },
    { slug: 'finland', name: 'Finland', language: 'fi', nativeName: 'Suomi' },
    { slug: 'france', name: 'France', language: 'fr', nativeName: 'France' },
    { slug: 'germany', name: 'Germany', language: 'de', nativeName: 'Deutschland' },
    { slug: 'greece', name: 'Greece', language: 'el', nativeName: 'Ελλάδα' },
    { slug: 'hungary', name: 'Hungary', language: 'hu', nativeName: 'Magyarország' },
    { slug: 'ireland', name: 'Ireland', language: 'en', nativeName: 'Ireland' },
    { slug: 'italy', name: 'Italy', language: 'it', nativeName: 'Italia' },
    { slug: 'latvia', name: 'Latvia', language: 'lv', nativeName: 'Latvija' },
    { slug: 'lithuania', name: 'Lithuania', language: 'lt', nativeName: 'Lietuva' },
    { slug: 'luxembourg', name: 'Luxembourg', language: 'fr', nativeName: 'Luxembourg' },
    { slug: 'malta', name: 'Malta', language: 'en', nativeName: 'Malta' },
    { slug: 'netherlands', name: 'Netherlands', language: 'nl', nativeName: 'Nederland' },
    { slug: 'poland', name: 'Poland', language: 'pl', nativeName: 'Polska' },
    { slug: 'portugal', name: 'Portugal', language: 'pt', nativeName: 'Portugal' },
    { slug: 'romania', name: 'Romania', language: 'ro', nativeName: 'România' },
    { slug: 'slovakia', name: 'Slovakia', language: 'sk', nativeName: 'Slovensko' },
    { slug: 'slovenia', name: 'Slovenia', language: 'sl', nativeName: 'Slovenija' },
    { slug: 'spain', name: 'Spain', language: 'es', nativeName: 'España' },
    { slug: 'sweden', name: 'Sweden', language: 'sv', nativeName: 'Sverige' },
];

export const EU_COUNTRY_FLAGS = {
    austria: AustriaFlag,
    belgium: BelgiumFlag,
    bulgaria: BulgariaFlag,
    croatia: CroatiaFlag,
    cyprus: CyprusFlag,
    czechia: CzechiaFlag,
    denmark: DenmarkFlag,
    estonia: EstoniaFlag,
    finland: FinlandFlag,
    france: FranceFlag,
    germany: GermanyFlag,
    greece: GreeceFlag,
    hungary: HungaryFlag,
    ireland: IrelandFlag,
    italy: ItalyFlag,
    latvia: LatviaFlag,
    lithuania: LithuaniaFlag,
    luxembourg: LuxembourgFlag,
    malta: MaltaFlag,
    netherlands: NetherlandsFlag,
    poland: PolandFlag,
    portugal: PortugalFlag,
    romania: RomaniaFlag,
    slovakia: SlovakiaFlag,
    slovenia: SloveniaFlag,
    spain: SpainFlag,
    sweden: SwedenFlag,
};

export const COUNTRY_LOCALE_MAP = {
    austria: 'de',
    belgium: 'nl',
    bulgaria: 'bg',
    croatia: 'hr',
    cyprus: 'el',
    czechia: 'cs',
    denmark: 'da',
    estonia: 'et',
    finland: 'fi',
    france: 'fr',
    germany: 'de',
    greece: 'el',
    hungary: 'hu',
    ireland: 'en',
    italy: 'it',
    latvia: 'lv',
    lithuania: 'lt',
    luxembourg: 'fr',
    malta: 'en',
    netherlands: 'nl',
    poland: 'pl',
    portugal: 'pt',
    romania: 'ro',
    slovakia: 'sk',
    slovenia: 'sl',
    spain: 'es',
    sweden: 'sv',
};

export const SEO_PAGE_LOCALES = {
    de: 'de_DE',
    nl: 'nl_NL',
    fr: 'fr_FR',
    es: 'es_ES',
    pt: 'pt_PT',
    it: 'it_IT',
    pl: 'pl_PL',
    cs: 'cs_CZ',
    sk: 'sk_SK',
    da: 'da_DK',
    sv: 'sv_SE',
    fi: 'fi_FI',
    el: 'el_GR',
    hu: 'hu_HU',
    ro: 'ro_RO',
    bg: 'bg_BG',
    hr: 'hr_HR',
    sl: 'sl_SI',
    et: 'et_EE',
    lv: 'lv_LV',
    lt: 'lt_LT',
    en: 'en_US',
};

export const formatCountryTemplate = (template, replacements) =>
    template.replace(/\{(\w+)\}/g, (_, key) => replacements[key] ?? '');

export const toCountryLandingSlug = (countrySlug, landingSuffix) => `${countrySlug}${landingSuffix}`;

export const normalizeCountryLandingSlug = (countrySlug, landingSuffix) => {
    const normalizedSlug = (countrySlug || '').toLowerCase().trim();
    return normalizedSlug.replace(new RegExp(`${landingSuffix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}$`), '');
};

export function resolveEuCountry(countrySlug, landingSuffix) {
    if (!countrySlug) {
        return null;
    }

    const normalizedSlug = normalizeCountryLandingSlug(countrySlug, landingSuffix);
    return EU_COUNTRIES.find((entry) => entry.slug === normalizedSlug) || null;
}

export function isValidCountryLandingSlug(countrySlug, landingSuffix) {
    return Boolean(resolveEuCountry(countrySlug, landingSuffix));
}

export function getEuHostLine(language, countryName) {
    const phrases = {
        de: 'Gehostet in Amsterdam mit direkten Routen für die schnellste Verbindung nach {countryName}.',
        nl: 'Gehost in Amsterdam met directe routes voor de snelste verbinding naar {countryName}.',
        fr: 'Hébergé à Amsterdam avec des routes directes pour la connexion la plus rapide vers {countryName}.',
        es: 'Alojado en Ámsterdam con rutas directas para la conexión más rápida hacia {countryName}.',
        pt: 'Hospedado em Amsterdã com rotas diretas para a conexão mais rápida com {countryName}.',
        it: 'Ospitato ad Amsterdam con percorsi diretti per la connessione più veloce verso {countryName}.',
        pl: 'Hostowane w Amsterdamie z bezpośrednimi trasami dla najszybszego połączenia z {countryName}.',
        cs: 'Hostováno v Amsterdamu s přímými trasami pro nejrychlejší spojení do {countryName}.',
        sk: 'Hostované v Amsterdame s priamymi trasami pre najrýchlejšie spojenie do {countryName}.',
        da: 'Hostet i Amsterdam med direkte ruter for den hurtigste forbindelse til {countryName}.',
        sv: 'Hostad i Amsterdam med direkta rutter för den snabbaste anslutningen till {countryName}.',
        fi: 'Isännöity Amsterdamissa suorilla reiteillä nopeinta yhteyttä varten kohteeseen {countryName}.',
        el: 'Φιλοξενείται στο Άμστερνταμ με απευθείας διαδρομές για τη γρηγορότερη σύνδεση προς {countryName}.',
        hu: 'Amszterdamban hosztolva, közvetlen útvonalakkal a leggyorsabb kapcsolathoz {countryName} felé.',
        ro: 'Găzduit în Amsterdam, cu rute directe pentru cea mai rapidă conexiune către {countryName}.',
        bg: 'Хоствано в Амстердам с директни маршрути за най-бързата връзка към {countryName}.',
        hr: 'Hostirano u Amsterdamu s izravnim rutama za najbržu vezu prema {countryName}.',
        sl: 'Gostovano v Amsterdamu z neposrednimi potmi za najhitrejšo povezavo do {countryName}.',
        et: 'Hostitud Amsterdamis otsete teedega, et tagada kiireim ühendus {countryName}-ga.',
        lv: 'Izvietots Amsterdamā ar tiešiem maršrutiem ātrākajam savienojumam ar {countryName}.',
        lt: 'Talpinama Amsterdame su tiesioginiais maršrutais greičiausiam ryšiui į {countryName}.',
        en: 'Hosted in Amsterdam with direct routes for the fastest connection to {countryName}.',
    };

    const template = phrases[language] || phrases.en;
    return formatCountryTemplate(template, { countryName });
}

export function buildEuCountryContext(countrySlug, {
    landingSuffix,
    baseCanonical,
    baseMeta,
    copyByLanguage,
    getSectionDetail,
    getExtraPoints,
    buildKeywords,
    europeFallback,
}) {
    const country = resolveEuCountry(countrySlug, landingSuffix);

    if (!country) {
        return {
            ...baseMeta,
            countrySlug: null,
            countryName: null,
            countryFlag: null,
            language: 'en',
            languageLabel: copyByLanguage.en.meta,
            badge: copyByLanguage.en.badge,
            heroIntro: copyByLanguage.en.heroIntro,
            heroTitle: copyByLanguage.en.heroTitle,
            hostLine: null,
            panelLabel: copyByLanguage.en.panelLabel,
            cta: copyByLanguage.en.cta,
            sectionTitle: null,
            sectionIntro: null,
            sectionDetail: null,
            sectionPoints: [],
        };
    }

    const language = COUNTRY_LOCALE_MAP[country.slug] || 'en';
    const copy = copyByLanguage[language] || copyByLanguage.en;
    const countryName = country.nativeName || country.name;

    return {
        title: formatCountryTemplate(copy.title, { countryName }),
        description: formatCountryTemplate(copy.intro, { countryName }),
        keywords: buildKeywords(countryName, country),
        canonical: `${baseCanonical}/${toCountryLandingSlug(country.slug, landingSuffix)}`,
        countrySlug: country.slug,
        countryName,
        countryFlag: EU_COUNTRY_FLAGS[country.slug] || null,
        language,
        languageLabel: copy.meta,
        badge: copy.badge,
        // Prefer title/intro (already country-aware) for H1 + lead so landings are not thin templates.
        heroIntro: formatCountryTemplate(copy.intro || copy.heroIntro, { countryName }),
        heroTitle: formatCountryTemplate(copy.title || copy.heroTitle || copyByLanguage.en.heroTitle, { countryName }),
        hostLine: getEuHostLine(language, countryName),
        panelLabel: copy.panelLabel,
        cta: copy.cta,
        sectionTitle: formatCountryTemplate(copy.title, { countryName }),
        sectionIntro: formatCountryTemplate(copy.intro, { countryName }),
        sectionDetail: getSectionDetail(language, countryName),
        sectionPoints: [...copy.points, ...getExtraPoints(language)],
    };
}

export function getEuCountryLandingPaths(baseCanonical, landingSuffix) {
    return EU_COUNTRIES.map(
        (country) => `${baseCanonical}/${toCountryLandingSlug(country.slug, landingSuffix)}`,
    );
}
